import base from './base'

let controller = 'project'
let action = null

const Project = {
  async listProjects (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListProjects'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addProject (request) {
    let model = {
      type: request.type || null,
      name: request.name || null,
      filingNo: request.filingNo || null,
      planLicenseNo: request.planLicenseNo || null,
      constrLicenceNo: request.constrLicenceNo || null,
      landLicenceNo: request.landLicenceNo || null,
      cityCode: request.cityCode || null,
      cityId: request.cityId || null,
      site: request.site || null,
      cost: request.cost || 0,
      area: request.area || 0,
      startdate: request.startdate || null,
      finishdate: request.finishdate || null,
      duration: parseInt(request.duration) || null,
      qualityRequirement: request.qualityRequirement || null
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateProject (request) {
    let model = {
      id: request.id || request.tid || null,
      type: request.type || null,
      name: request.name || null,
      filingNo: request.filingNo || null,
      planLicenseNo: request.planLicenseNo || null,
      constrLicenceNo: request.constrLicenceNo || null,
      landLicenceNo: request.landLicenceNo || null,
      cityCode: request.cityCode || null,
      cityId: request.cityId || null,
      site: request.site || null,
      cost: request.cost || null,
      area: request.area || null,
      startdate: request.startdate || null,
      finishdate: request.finishdate || null,
      duration: parseInt(request.duration) || null,
      qualityRequirement: request.qualityRequirement || null
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async getProject (projectId) {
    if (!projectId) {
      throw new Error('ProjectId为空')
    }
    action = `Detail/${projectId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async deleteProject (companyId) {
    if (!companyId) {
      throw new Error('ProjectId为空')
    }
    action = `Delete/${companyId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getPrjTypes () {
    action = `GetPrjTypes`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async searchProjects (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      name: query.name || null,
      cityId: query.cityId || null,
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ProjectSearch'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  }
}

export default Project